import { ProtocolKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { ProtocolDisplay } from "../protocol-display";
import { ButtonV2 } from "../button-v2";
import { CheckmarkIcon } from "../../icons";

export interface ProtocolGroupProps {
  className?: string;
  runtimeProtocolKeys: ProtocolKey[];
  protocolKey: ProtocolKey;
  setProtocol: (value: ProtocolKey) => void;
}

export function ProtocolGroup({
  className,
  runtimeProtocolKeys,
  protocolKey,
  setProtocol,
}: ProtocolGroupProps): JSX.Element {
  return (
    <div className="flex flex-col gap-10">
      <div className="text-xl font-medium text-white">Network</div>

      <div
        className={cn(
          "flex flex-col gap-5 items-stretch sm:items-start",
          className
        )}
      >
        {runtimeProtocolKeys.map((_protocolKey) => {
          const isSelected = _protocolKey === protocolKey;

          return (
            <ButtonV2
              key={_protocolKey}
              variant="secondary"
              onClick={() => setProtocol(_protocolKey)}
              className="flex items-center justify-between gap-5"
              isSelected={isSelected}
            >
              <ProtocolDisplay protocolKey={_protocolKey} />

              {isSelected && <CheckmarkIcon className="w-6 h-6" />}
            </ButtonV2>
          );
        })}
      </div>
    </div>
  );
}
